<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [fill]="chartOptions.fill!"
        [dataLabels]="chartOptions.dataLabels!"
        [title]="chartOptions.title!"
        [legend]="chartOptions.legend!"
        [yaxis]="chartOptions.yaxis!"
        [grid]="chartOptions.grid!"
    ></apx-chart>
</div>